import React, { useState } from 'react';
import Link from 'redux-first-router-link';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Information from './Information';
import CartItems from '../../Selection/CartItems';
import { goToPage } from '../../../actions/environment';
import { updateAccountAddress, updateAccountEmail, updateAccountPassword, changeAddressInput, accountOrders } from '../../../actions/checkout';
import { purifier } from '../../../utils/dom';
import { prefix, translate } from '../../../utils/locale';
import s from './Authenticated.scss';

const sections = [
	'accountInformation',
	'accountPreviousOrders',
	'accountFavourites',
	'accountBenefits',
	'accountCustomerCare',
	'accountSignOut',
];

const PreviousOrders = ({ setup, checkout, ...props }) => {
	const loadMoreOrdersHandler = (e) => {
		e.preventDefault();
		props.accountOrders();
	};

	return (
		<div className={s.authenticated_section_content_inner}>
			{
				checkout?.account?.orders && checkout?.account?.orders.length > 0 ? (
					<div className={s.authenticated_section_content_inner_orders}>
						{
							checkout.account.orders.map((order) => (
								<div className={s.authenticated_section_content_inner_order}>
									<span>{ order.date.slice(0, order.date.indexOf(' ')).replace(/-/g, '.') }</span>
									<br />
									<p className={s.authenticated_section_content_inner_order_info}><Link to={prefix(setup, `account/order-${order.order}`)}>{ `#${order.order}` }</Link><span>{ `${order.items[0].product.name} ${order.items[0].product.variantName}` }</span><Link to={prefix(setup, `account/order-${order.order}`)}>{ translate(setup, 'accountViewOrder') }</Link></p>
								</div>
							))
						}
						{
							checkout.account.hasMoreOrders && (
								<a className={s.authenticated_section_content_inner_action} href="#edit-information" onClick={loadMoreOrdersHandler}>
									<span>{ translate(setup, 'accountOrdersShowMore') }</span>
								</a>
							)
						}
					</div>
				) : (
					<div dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'accountNoOrders')) }} />
				)
			}
		</div>
	);
};

const Favourites = ({ setup, favourites }) => (
	<div className={[s.authenticated_section_content_inner, s.authenticated_section_content_inner__favourites].join(' ')}>
		<CartItems favourites displayGrid />
		{
			favourites.length > 0 && (
				<Link className={s.authenticated_section_content_inner_action} to={prefix(setup, `/favourites/${favourites.join(',')}`)}>
					<span>{ translate(setup, 'accountFavouritesShare') }</span>
				</Link>
			)
		}
	</div>
);

const Authenticated = ({ setup, checkout, favourites, ...props }) => {
	const [accordianToggled, toggleAccordian] = useState(sections.reduce((acc, section) => ({ ...acc, [section]: false }), {}));

	const toggleAccordianHandler = (e) => {
		e.preventDefault();
		const value = e.currentTarget.value;

		if (value === 'accountPreviousOrders' && !checkout.account?.orders && (typeof checkout.account.hasMoreOrders === 'undefined' || checkout.account.hasMoreOrders)) {
			// Get latest orders
			props.accountOrders();
		}

		toggleAccordian((prevState) => ({
			...prevState,
			[value]: !prevState[value],
		}));
	};

	return (
		<div className={s.authenticated}>
			<section className={s.authenticated_section}>
				<div className={s.authenticated_section_content}>
					<div className={s.authenticated_section_content_inner} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'accountIntro')) }} />
				</div>
			</section>
			{
				sections.map((section, i) => (
					<section className={[s.authenticated_section, (accordianToggled[section] ? s.authenticated_section__expanded : null)].join(' ')}>
						<button aria-controls={section} aria-expanded={accordianToggled[section]} type="button" onClick={toggleAccordianHandler} className={s.authenticated_section_title} value={section}>
							<span>{ `${i + 1}. ${translate(setup, `${section}Title`)}` }</span>
						</button>
						<div aria-hidden={!accordianToggled[section]} id={section} className={[s.authenticated_section_content, s[`authenticated_section_content__${section}`]].join(' ')}>
							{
								section === 'accountInformation' && (
									<div className={s.authenticated_section_content_inner}>
										<Information setup={setup} checkout={checkout} {...props} />
									</div>
								)
							}
							{ section === 'accountPreviousOrders' && <PreviousOrders setup={setup} checkout={checkout} {...props} /> }
							{ section === 'accountFavourites' && <Favourites setup={setup} favourites={favourites} /> }
							{ section === 'accountBenefits' && <div className={s.authenticated_section_content_inner} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'accountBenefitsContent')) }} /> }
							{ section === 'accountCustomerCare' && <div className={s.authenticated_section_content_inner} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'accountCustomerCareContent')) }} /> }
							{ section === 'accountSignOut' && <div className={s.authenticated_section_content_inner} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'accountSignOutContent')) }} /> }
						</div>
					</section>
				))
			}
		</div>
	);
};

const mapState = ({ environment, checkout }, props) => ({ checkout, favourites: environment.favourites, ...props });

export default hot(module)(connect(mapState, { updateAccountAddress, updateAccountEmail, updateAccountPassword, changeAddressInput, goToPage, accountOrders })(Authenticated));
